<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-avatar class="mt-5 mr-6 mb-5 user-avatar" size="40" color="white" v-on="on">
        <span id="top-user-menu--user-initials" class="black--text headline">
          {{ userInitials }}
        </span>
      </v-avatar>
    </template>
    <v-list>
      <v-list-item v-for="(menuItem, index) in menuItems" :key="index" :href="menuItem.href">
        <v-icon left>mdi-exit-to-app</v-icon>
        <v-list-item-title>{{ menuItem.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
        {
          icon: '',
          label: 'Logout',
          href: '/logout'
        }
      ]
    };
  },

  computed: {
    userInitials() {
      let initials = 'GU';

      if (this.$store.state.sessionUser) {
        if (this.$store.state.sessionUser.givenName || this.$store.state.sessionUser.surname) {
          initials = '';
          initials += this.$store.state.sessionUser.givenName.substring(0, 1);
          initials += this.$store.state.sessionUser.surname.substring(0, 1);
        }
      }

      return initials;
    }
  }
};
</script>
<style scoped>
.user-avatar {
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0.105em;
  text-transform: uppercase;
}
</style>
